<form [formGroup]="fG">
  <div [class.e-error]="fG.controls[fCN].invalid && fG.controls[fCN].dirty">
    <ejs-timepicker
      [placeholder]="placeholder"
      [formControlName]="fCN"
      [cssClass]="cssClass"
      [step]="step">
    </ejs-timepicker>
  </div>

  @if (hasErrorField) {
    <div class="error-label" role="alert">
      {{ errorText && fG.controls[fCN].invalid && fG.controls[fCN].dirty ? errorText : '' }}
    </div>
  }
</form>
